import React from "react";
import JsonVariablePanel from "./JsonVars/JsonVariablePanel";
import ScriptVariablePanel from "./ScriptVars/ScriptVariablePanel";
import { Box, Stack } from "@atlaskit/primitives";


const PreRequestVariables = ({ action }) => {

  return (
    <Box>
      <Stack>
          <ScriptVariablePanel action={action} />
      </Stack>
      <Stack>
          <JsonVariablePanel action={action} />
      </Stack>
    </Box>
  );
};

export default PreRequestVariables;
